.page {
  position: relative;
  min-height: 100vh;
  padding-top: calc(var(--nav-height) + clamp(28px, 6vh, 64px));
  padding-bottom: clamp(64px, 10vh, 120px);
  padding-left: var(--page-padding);
  padding-right: var(--page-padding);
  background: radial-gradient(
      1200px 800px at 80% -10%,
      var(--brand-steel-faint),
      transparent 60%
    ),
    radial-gradient(
      900px 600px at -10% 100%,
      var(--brand-ember-faint),
      transparent 60%
    ),
    var(--color-bg-primary);
}

.back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 28px;
  font-family: var(--font-dm-sans);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
}

.back:hover {
  color: var(--brand-ember);
}

/* ──────────── LAYOUT ──────────── */
.layout {
  display: grid;
  /* Cap the gallery column so the hero doesn't balloon to half the viewport;
     the info column takes the rest. --hero-max is tunable (see ProductDetailTuner). */
  grid-template-columns: minmax(0, var(--hero-max, 380px)) minmax(0, 1fr);
  gap: var(--panel-gap, 48px);
  max-width: 1100px;
  margin: 0 auto;
  align-items: start;
}

@media (max-width: 820px) {
  .layout {
    /* minmax(0, …), not plain 1fr: a 1fr track can't shrink below its widest child, and the
       thumbnail strip's min-content is every thumbnail side by side — a product with five or
       more photos laid the whole page out wider than the phone. */
    grid-template-columns: minmax(0, 1fr);
    gap: 32px;
  }
}

/* ──────────── GALLERY ──────────── */
.gallery {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.hero {
  width: 100%;
  /* height:auto is required — without it the <img height="1000"> attribute
     leaks through as a presentational hint, which (paired with an explicit
     width) makes the browser IGNORE aspect-ratio and render a tall box.
     Printify mockups are square (1200×1200), so this yields a clean square. */
  height: auto;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  display: block;
  background: var(--brand-paper);
  border-radius: var(--gallery-radius, 16px);
}

.thumbs {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.thumb {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  padding: 0;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-sm);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.thumb:hover {
  border-color: var(--brand-steel);
}

.thumbActive {
  border-color: var(--brand-ember);
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ──────────── INFO ──────────── */
.info {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.title {
  font-family: var(--font-syne);
  font-size: clamp(1.75rem, 3vw, 2.75rem);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.1;
  color: var(--color-text-primary);
  margin: 0;
}

.price {
  font-family: var(--font-dm-sans);
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--brand-ember);
}

.desc {
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-family: var(--font-dm-sans);
  font-size: 0.95rem;
  line-height: 1.65;
  color: var(--color-text-secondary);
  max-width: 60ch;
  white-space: pre-line;
}
